<!-- 资料信息 -->
<template>
  <div class="data-info-view">
    <p class="info-title">资料信息&nbsp;&nbsp;{{ fileList.length }}</p>

    <div class="data-info-content">
      <el-form>
        <el-form-item label-width="120" label="公司介绍资料：">
          <MyFileUpload
            :upLoadFileList="fileList"
            :limitCount="9999999"
            @upFileKey="(e, f, p) => uploadDocSuccess(e, f, p)"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// api
import { getFileInfo, updateFileInfo } from "@/api/enterprise.js";
// components
import MyFileUpload from "@/components/MyFileUpload/index.vue";
export default {
  components: {
    MyFileUpload
  },
  data() {
    //这里存放数据
    return {
      fileList: [],
      fileData: []
    };
  },
  methods: {
    getInfo() {
      getFileInfo({ id: this.$route.query.companyCode }).then(res => {
        if (res.code === 200 && Array.isArray(res.data)) {
          this.fileList = res.data.map(res => {
            return {
              url: res.fileUrl,
              name: res.fileName
            };
          });

          this.fileData = res.data;
        }
      });
    },
    submit(isDelete = false) {
      updateFileInfo(this.fileData)
        .then(res => {
          if (res.code === 200) {
            if(isDelete) {
              this.$message.success("删除成功");
            } else {
              this.$message.success("添加成功");
            }
            this.getInfo();
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
    uploadDocSuccess(list, file, project) {
      if (Array.isArray(list)) {
        if (list.length < this.fileData.length) {
          const index = this.fileData.findIndex(item => {
            return item.fileUrl === file.url
          })

          if (index !== -1) {
            this.fileData.splice(index, 1);

            this.$nextTick(() => {
              this.submit(true);
            });
          }
        } else {
          this.fileData.push({
            fileName: project.name,
            companyId: this.$route.query.companyCode,
            fileUrl: file.url
          });
          this.$nextTick(() => {
            this.submit();
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.data-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    margin-left: 98px;
    font-size: 18px;
    line-height: 25px;
  }

  .upload-box {
    display: flex;
    align-items: center;
  }

  .data-info-content {
    margin-left: 78px;
  }

  .upload-box {
    .label {
      font-size: 16px;
    }
  }

  .upload-list {
    margin-top: 22px;

    .upload-item {
      display: flex;
      margin-bottom: 10px;
      font-size: 14px;

      .download-btn {
        margin: 0 28px;
        font-size: 14px;
        color: #1e9fff;
      }

      .delete-btn {
        color: #ff6c66;
      }
    }
  }
}
</style>
